import { __spreadArray } from "tslib";
var normalizeSnippetBuffer = function (buffer) {
    return buffer.map(function (_a) {
        var methodName = _a[0], args = _a.slice(1);
        return ({
            method: methodName,
            resolve: function () { },
            reject: console.error,
            args: args,
            called: false,
        });
    });
};
/**
 * Fetch the buffered method calls from the window object and normalize them.
 */
export var getSnippetWindowBuffer = function () {
    var wa = window.analytics;
    var buffered = 
    // @ts-expect-error
    (wa && wa[0] ? __spreadArray([], wa, true) : []);
    return normalizeSnippetBuffer(buffered);
};
//# sourceMappingURL=snippet.js.map